import { gql } from "apollo-boost";

export const GET_ATTRIBUTES = gql`
query Attributes($where: AttributeWhereInput, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
  attributes(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
    total
    data {
      id
      name
      shop {
        id
        name
      }
      isDeleted
      createdAt
      updatedAt
      note
    }
  }
}
`